<template>
  <BasePage title="Login" :container="false">
    <div class="columns is-desktop ">
      <div class="column is-one-third is-offset-one-third">
      <section class="mt-4">
        <h1 class="title is-2">Request a Demo</h1>

        <form action="" method="post" @submit.prevent="requestDemo()">
          <div class="field">
            <label class="label">Name</label>
            <p class="control">
              <input
                :class=" error && 'is-danger'"
                v-model="Name"
                class="input"
                type="text"
                placeholder="Your Name"
                required
                />
            </p>
          </div>

          <div class="field">
            <label class="label">Educator Email</label>
            <p class="control">
              <input
                v-focus
                v-model="email"
                :class=" error && 'is-danger'"
                class="input"
                type="email"
                placeholder="Your Educator Email"
                required
                />
            </p>
          </div>

          <div class="field">
            <label class="label">School or Program</label>
            <p class="control">
              <input
                :class=" error && 'is-danger'"
                v-model="group"
                class="input"
                type="text"
                placeholder="Your School or Program"
                required
                />
            </p>
          </div>

          <div class="field">
            <label class="label">Phone</label>
            <p class="control">
              <input
                :class=" error && 'is-danger'"
                v-model="phone"
                class="input"
                type="text"
                placeholder="Phone Number"
                required
                />
            </p>
          </div>


          <div class="field">
            <p class="control flex-space-between flex-align-center">
              <button class="button is-primary">Request Demo</button>
            </p>
          </div>
          <p class="login-error" v-if="error">{{ errorMessage }}</p>
        </form>
      </section>
    </div>
  </div>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import { focus } from '../directives.js'

import store from '../store.js'

export default {
  name: 'RequestDemo',
  data () {
    return {
      email: '',
      group: '',
      name: '',
      phone: '',
    }
  },
  components: {
    BasePage,
  },
  methods: {
    requestDemo () {
      const { email, group, name, phone } = this
      store.dispatch('requestDemo', { email, group, name, phone })
      .then(() => {
        store.commit('notify', { message: 'Thanks! Someone will be reaching out shortly to schedule a time.', level: 'success' })
        setTimeout(function () { window.location.href = 'https://classforward.com' }, 2000)
      })
    },
  },
  computed: {
    error () {
      return store.state.loginErrorMessage !== ''
    },
    errorMessage () {
      return store.state.loginErrorMessage
    },
  },
  directives: {
    focus,
  },
}
</script>

<style lang="scss" scoped>

@import '../_variables.scss';

.login-error {
  color: $DANGER;
  transition: all 0.5 ease;
  text-align: center;
  font-style: italic;
}

.container {
    margin: initial;
}

.button {
	width: 100%;
}

label {
	display: none;
}

</style>



// WEBPACK FOOTER //
// RequestDemo.vue?41a4fb10